






























































































































































































































































































































import Vue from "vue";
import Header from "@/components/Header.vue";

const FACTORES_ACTIVIDAD: Record<string, number> = {
  Sedentario: 1.2,
  Ligero: 1.375,
  Moderado: 1.55,
  Activo: 1.725,
  MuyActivo: 1.9,
};

interface ResultadoCalorias {
  tmb: number;
  tdee: number;
  deficit: number;
  superavit: number;
}

export default Vue.extend({
  name: "Calorias-Diarias",
  components: { Header },
  data() {
    return {
      Sexo: null as string | null,
      NivelEjercicio: null as string | null,
      Altura: null as number | null,
      Peso: null as number | null,
      Edad: null as number | null,
      resultado: null as ResultadoCalorias | null,
      error: "" as string,
      mostrarRecursos: false,
    };
  },
  computed: {
    sexoOpts(): Array<{ text: string; value: string | null }> {
      return [
        { text: String(this.$t("common.seleccionar")), value: null },
        { text: String(this.$t("common.masculino")), value: "Masculino" },
        { text: String(this.$t("common.femenino")), value: "Femenino" },
      ];
    },
    nivelOpts(): Array<{ text: string; value: string | null }> {
      return [
        { text: String(this.$t("common.seleccionar")), value: null },
        { text: String(this.$t("calorias.sedentario")), value: "Sedentario" },
        { text: String(this.$t("calorias.ligero")), value: "Ligero" },
        { text: String(this.$t("calorias.moderado")), value: "Moderado" },
        { text: String(this.$t("calorias.activo")), value: "Activo" },
        { text: String(this.$t("calorias.muy_activo")), value: "MuyActivo" },
      ];
    },
  },
  created() {
    const p = this.$store.state.profile;
    if (p.sexo) this.Sexo = p.sexo;
    if (p.altura) this.Altura = p.altura;
    if (p.peso) this.Peso = p.peso;
    if (p.edad) this.Edad = p.edad;
  },
  methods: {
    calcular() {
      this.error = "";
      this.resultado = null;

      if (!this.Sexo) {
        this.error = "Por favor selecciona tu sexo biológico.";
        return;
      }
      if (!this.NivelEjercicio) {
        this.error = "Por favor selecciona tu nivel de ejercicio.";
        return;
      }
      if (!this.Altura || !this.Peso || !this.Edad) {
        this.error = "Por favor completa todos los campos.";
        return;
      }

      let tmb: number;
      if (this.Sexo === "Masculino") {
        tmb = 10 * this.Peso + 6.25 * this.Altura - 5 * this.Edad + 5;
      } else {
        tmb = 10 * this.Peso + 6.25 * this.Altura - 5 * this.Edad - 161;
      }

      const factor = FACTORES_ACTIVIDAD[this.NivelEjercicio];
      const tdee = Math.round(tmb * factor);

      this.resultado = {
        tmb: Math.round(tmb),
        tdee,
        deficit: Math.max(1200, tdee - 500),
        superavit: tdee + 300,
      };
      this.$store.commit("setProfile", {
        sexo: this.Sexo,
        altura: this.Altura,
        peso: this.Peso,
        edad: this.Edad,
        tdee,
      });
    },
  },
});
